<template>
  <router-view :class="classList" ></router-view>
</template>

<style>


    body, html {
        overflow-x: visible !important;
        overflow-y: visible !important;
    }
    .v-card__text, .v-card__title {
      word-break: normal!important; /* maybe !important  */
    }

    .mobile {
      padding: 0!important;
    }

    .hide { display: none; }
  .action-button {
    text-decoration: none;
    font-size: 1rem!important;
    line-height: 1.5rem!important;
    font-weight: 500!important;
    /*background: linear-gradient(145deg,rgb(248 27 231) 0%,rgb(241 47 110) 50%,rgb(220 24 106))!important;*/
    background:linear-gradient(90deg, rgba(255,81,82,1) 0%, rgba(255,55,117,1) 49%, rgba(254,0,148,1) 100%)!important;
    display: flex!important;
    width: 100%!important;
    height: 3rem!important;
    border-radius: 0.25rem!important;
    align-items: center!important;
    justify-content: center!important;
    padding: 0.75rem 1.5rem!important;
    box-sizing: border-box!important;
    border-radius: 50px!important;
    color: rgba(255,255,255,1)!important;
    width:170px!important;
  }


    .rtl.v-application .float-right.rtl{
    float:left!important;
  }

 .rtl.v-application .text-left{
   text-align:right!important;
  }

    .rtl .dark-theme .theme--light.v-card > .v-card__text, .rtl .theme--light.v-card .v-card__subtitle {

      padding-left: 0;
      padding-right: 16px!important;

    }

  .rtl .v-application .text-left {

    text-align:right !important;

  }

    .rtl .v-application ul, .v-application ol {
      padding-left: 0px!important;
      padding-right: 24px!important;
    }

</style>

<script>
  import config from './config'
  import 'flag-icon-css/css/flag-icon.css'
  import {mapState}  from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState(['signInToken']),
    classList(){

      return this.$vuetify.rtl? 'rtl' : '';

    }

  },

  created(){



    this.$store.dispatch('created');

    this.$gapi.constructor.prototype.currentGoogleUser = function() {
      return this._libraryInit('auth2')
              .then(auth => {
                if (auth.isSignedIn.get()) {
                  return Promise.resolve(auth.currentUser.get())
                } else {
                  return Promise.resolve(null)
                }
              });
    };



    this.user = localStorage.user? JSON.parse(localStorage.user) : {};


    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${config.payment.paypal.clientId}&vault=true`);
    document.head.appendChild(recaptchaScript)



  }
};
</script>
